export default {
  color: ["rgba(76, 145, 246, 1)", "rgba(82, 204, 197, 1)"],
  grid: {
    right: 10,
    top: "18%",
    bottom: "10%",
    left: 15,
    containLabel: true,
  },
  legend: {
    top: "15px",
    icon: "rect",
    itemHeight: 5,
    itemWidth: 15,
    right: 10,
    data: [],
    textStyle: {
      color: "#FFFFFFA6",
    },
    selectedMode: false,
  },
  tooltip: {
    trigger: "none",
    axisPointer: {
      type: "cross",
    },
  },
  xAxis: [
    {
      show: false,
      type: "category",
      axisTick: {
        alignWithLabel: true,
      },
      axisLine: {
        lineStyle: {
          color: "rgba(76, 145, 246, 0.2)",
        },
      },
      axisPointer: {
        label: {
          backgroundColor: "rgba(76, 145, 246, 1)",
        },
      },
      axisLabel: {
        color: "#FFFFFFA6",
      },
      data: [],
    },
    {
      show: false,
      type: "category",
      axisTick: {
        alignWithLabel: true,
      },
      axisLine: {
        lineStyle: {
          color: "rgba(82, 204, 197, 0.2)",
        },
      },
      axisPointer: {
        label: {
          backgroundColor: "rgba(82, 204, 197, 1)",
        },
      },
      axisLabel: {
        color: "#FFFFFFA6",
      },
      data: [],
    },
  ],
  yAxis: {
    name: "",
    show: true,
    type: "value",
    alignTicks: true,
    splitNumber: 3,
    axisLine: {
      lineStyle: {
        color: "#FFFFFFA6",
      },
    },
    splitLine: {
      lineStyle: {
        color: "rgba(255, 255, 255, .2)",
        type: "dashed",
      },
    },
    axisLabel: {
      color: "#FFFFFFA6",
    },
  },
  series: [],
  graphic: [{}],
}
